/**
 * License API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OrderItemStatus = 'unknown' | 'cancelledSubscription' | 'newSubscription' | 'reactivatedSubscription' | 'failedNotFound' | 'failedInvalidPricing' | 'failedInvalidDuration' | 'failedRequiresReconnectionFee' | 'failedAlreadyActiveSubscription' | 'failedNoActiveSubscription';

export const OrderItemStatus = {
    Unknown: 'unknown' as OrderItemStatus,
    CancelledSubscription: 'cancelledSubscription' as OrderItemStatus,
    NewSubscription: 'newSubscription' as OrderItemStatus,
    ReactivatedSubscription: 'reactivatedSubscription' as OrderItemStatus,
    FailedNotFound: 'failedNotFound' as OrderItemStatus,
    FailedInvalidPricing: 'failedInvalidPricing' as OrderItemStatus,
    FailedInvalidDuration: 'failedInvalidDuration' as OrderItemStatus,
    FailedRequiresReconnectionFee: 'failedRequiresReconnectionFee' as OrderItemStatus,
    FailedAlreadyActiveSubscription: 'failedAlreadyActiveSubscription' as OrderItemStatus,
    FailedNoActiveSubscription: 'failedNoActiveSubscription' as OrderItemStatus
};

